import React from 'react';
import clsx from 'clsx';

export const Card = ({ className, children, ...props }) => {
  return (
    <div
      className={clsx(
        'bg-[var(--card)] rounded-[var(--radius-md)] shadow-[var(--shadow-sm)] border border-[var(--muted)]/50',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export const CardHeader = ({ className, children, ...props }) => {
  return (
    <div className={clsx('p-4 pb-2', className)} {...props}>
      {children}
    </div>
  );
};

export const CardTitle = ({ className, children, ...props }) => {
  return (
    <h3 className={clsx('font-heading text-lg font-semibold text-[var(--fg)]', className)} {...props}>
      {children}
    </h3>
  );
};

export const CardDescription = ({ className, children, ...props }) => {
  return (
    <p className={clsx('text-sm text-[var(--fg)]/70 mt-1', className)} {...props}>
      {children}
    </p>
  );
};

export const CardContent = ({ className, children, ...props }) => {
  return (
    <div className={clsx('p-4 pt-2', className)} {...props}>
      {children}
    </div>
  );
};

export const CardFooter = ({ className, children, ...props }) => {
  return (
    <div className={clsx('p-4 pt-0 flex items-center gap-2', className)} {...props}>
      {children}
    </div>
  );
};